import React, { useEffect, useState } from 'react';
import { Box, Card, CircularProgress, Grid, Typography } from '@mui/material';
import { branchDashboard } from '../../services/branchApi';

const Stat = ({ label, value }: { label: string; value: React.ReactNode }) => (
  <Card sx={{ p: 2.5 }}>
    <Typography variant="body2" color="text.secondary">{label}</Typography>
    <Typography variant="h5" fontWeight={700}>{value}</Typography>
  </Card>
);

export default function BranchDashboard() {
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => { branchDashboard().then(setData).finally(() => setLoading(false)); }, []);

  if (loading) return <Box sx={{ p: 4, textAlign: 'center' }}><CircularProgress /></Box>;
  const k = data?.kpis;
  return (
    <Box>
      <Typography variant="h5" fontWeight={700} sx={{ mb: 2 }}>Dashboard</Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={3}><Stat label="Total Users" value={k?.totalUsers ?? 0} /></Grid>
        <Grid item xs={12} sm={6} md={3}><Stat label="Executives" value={k?.executives ?? 0} /></Grid>
        <Grid item xs={12} sm={6} md={3}><Stat label="Pending Deposits" value={k?.deposits?.pending ?? 0} /></Grid>
        <Grid item xs={12} sm={6} md={3}><Stat label="Pending Withdrawals" value={k?.withdrawals?.pending ?? 0} /></Grid>
        <Grid item xs={12} sm={6} md={3}><Stat label="Approved Deposits" value={k?.deposits?.approved ?? 0} /></Grid>
        <Grid item xs={12} sm={6} md={3}><Stat label="Deposit Amount" value={`₹${(k?.deposits?.approvedAmount ?? 0).toLocaleString()}`} /></Grid>
        <Grid item xs={12} sm={6} md={3}><Stat label="Completed Withdrawals" value={k?.withdrawals?.done ?? 0} /></Grid>
        <Grid item xs={12} sm={6} md={3}><Stat label="Withdraw Amount" value={`₹${(k?.withdrawals?.doneAmount ?? 0).toLocaleString()}`} /></Grid>
      </Grid>
    </Box>
  );
}
